var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z",
    fill: "#56A012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.32 62.32C41.52 62.32 40.76 62 40.2 61.44L28.88 50.12C27.72 48.96 27.72 47.04 28.88 45.88C30.04 44.72 31.96 44.72 33.12 45.88L42.32 55.08L62.88 34.52C64.04 33.36 65.96 33.36 67.12 34.52C68.28 35.68 68.28 37.6 67.12 38.76L44.44 61.44C43.88 62 43.12 62.32 42.32 62.32Z",
    fill: "#56A012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.41ea473da0951210c75ee8d1294fb000.svg";
export { ForwardRef as ReactComponent };